import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import LogoStrip from "@/components/landing/LogoStrip";
import Features from "@/components/landing/Features";
import UseCases from "@/components/landing/UseCases";
import HowItWorks from "@/components/landing/HowItWorks";
import RateCalculator from "@/components/landing/RateCalculator";
import SupportedCoins from "@/components/landing/SupportedCoins";
import Testimonials from "@/components/landing/Testimonials";
import FAQ from "@/components/landing/FAQ";
import ContactNewsletter from "@/components/landing/ContactNewsletter";
import Footer from "@/components/landing/Footer";

export default function LandingPage() {
  return (
    <div className="min-h-screen bg-white text-slate-900" data-testid="landing-page">
      <Navbar />
      <main>
        <Hero />
        <LogoStrip />
        <Features />
        <UseCases />
        <HowItWorks />
        <RateCalculator />
        <SupportedCoins />
        <Testimonials />
        <FAQ />
        <ContactNewsletter />
      </main>
      <Footer />
    </div>
  );
}
